var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
export function clamp(v, min, max) {
    return v < min ? min : v > max ? max : v;
}
export function getState(node) {
    var _a;
    var state = (_a = node.metadata) === null || _a === void 0 ? void 0 : _a.componentState;
    if (state && typeof state === 'object')
        return state;
    return {};
}
export function setState(node, patch) {
    node.metadata.componentState = __assign(__assign({}, getState(node)), patch);
}
/** Minimal synthetic event for component state changes (Phase 6). */
export function syntheticEvent(type, target, extra) {
    if (extra === void 0) { extra = {}; }
    var noop = function () { return undefined; };
    return __assign({ type: type, target: target, originalEvent: new Event(type), x: 0, y: 0, worldX: 0, worldY: 0, preventDefault: noop, stopPropagation: noop }, extra);
}
export function emitChange(node, value, field) {
    var _a;
    var _b;
    if (field === void 0) { field = 'value'; }
    setState(node, (_a = {}, _a[field] = value, _a));
    node.emit('change', syntheticEvent('change', node, { value: value, field: field }));
    (_b = node.getApp()) === null || _b === void 0 ? void 0 : _b.requestRender();
}
export function componentToJSON(node) {
    var _a;
    var componentType = (_a = node.metadata) === null || _a === void 0 ? void 0 : _a.componentType;
    if (!componentType)
        return node.toJSON();
    var state = getState(node);
    var json = {
        type: componentType,
        id: node.id,
        props: __assign({ x: node.x, y: node.y, rotation: node.rotation, scaleX: node.scaleX, scaleY: node.scaleY, opacity: node.opacity, visible: node.visible, name: node.name || undefined }, state),
    };
    if ('children' in node && node.children.length > 0) {
        var compound = ['tabs', 'accordion', 'menu', 'toolbar', 'table', 'tree', 'dialog', 'statusBar'];
        if (compound.includes(componentType)) {
            json.children = node.children.map(function (child) { return componentToJSON(child); });
        }
    }
    return json;
}
export function bindApp(node, app) {
    var e_1, _a;
    node._app = app;
    if ('children' in node) {
        try {
            for (var _b = __values(node.children), _c = _b.next(); !_c.done; _c = _b.next()) {
                var child = _c.value;
                bindApp(child, app);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
}
export function num(props, key, fallback) {
    var v = props[key];
    return typeof v === 'number' ? v : fallback;
}
export function str(props, key, fallback) {
    if (fallback === void 0) { fallback = ''; }
    var v = props[key];
    return typeof v === 'string' ? v : fallback;
}
export function bool(props, key, fallback) {
    if (fallback === void 0) { fallback = false; }
    var v = props[key];
    return typeof v === 'boolean' ? v : fallback;
}
export function getParts(node) {
    var _a;
    var parts = (_a = node.metadata) === null || _a === void 0 ? void 0 : _a._parts;
    return parts && typeof parts === 'object' ? parts : {};
}
export function setParts(node, parts) {
    node.metadata._parts = parts;
}
